export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKQWRkLVJLU0otSGELgUEBvU8AAMBMAADAUgsBvVEJAr1TAgS9VgAAwFoAAMBTAADAWAAAwFUAEb1bQQqCn71uAQABAAEAAQAZAB8AAQABAAYAYQGC8wHASEEKg0C9eAEAAQABAAEAGQAgAAEAAQAGAGEHg5UBvgKB0WEAvgcAAL4EAADBCQAAvgUAAMEKAAHBE1EL7IC+CYYQhg8GhhiGFweGEgSGE4YIYQfsiwHBHQAAwSYAAMElAADBIQAAwSQEAMEEhXwAwQ0=", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/Add-RKSJ-V.bcmap
// module id = DWZh
// module chunks = 0